import { useAccount } from '@hcs/auth';

export const useGlobalEngagementTrackingCallbackDeps = () => {
  // Loads dependent data so the listeners get rebound with the updated data
  const accountQuery = useAccount();
  return [accountQuery.data];
};
